export const findCompanies = `
{
  findCompanies{
    id,
    socialName
  }
}`
